<template>
  <CCard>
    <CCardHeader>
      <strong>New Faq</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput label="Question" placeholder="Enter topic name" v-model="question" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="Answer" placeholder="Enter Terms & Condition" v-model="answer"
                     rows="10" />
        </CCol>
      </CRow>

    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Add Faq
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "FaqCreate",
  data() {
    return {
      question: "",
      answer: "",

    };
  },
  created() {

  },
  methods: {

    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "answer-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("question", this.question);
      formData.append("answer", this.answer);




      this.$axios
          .post(`${ADMIN_URL}/faqs/store`, formData, config)
          .then((response) => {
            console.log("Success", response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal("Success", response.data.message, "success");
            window.location.href = "/faqs";
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            currentObj.output = error;
            this.$swal("Error", error.response.message, "error");
          });
    },


  },
};
</script>

<style scoped>
</style>
